import { AccessLevel, SubscriptionPlanHelpers, SubscriptionPlanKey } from "@authory-packages/core";

export const getPlanTierLabel = (subscriptionPlanKey: SubscriptionPlanKey | null) => {
    const accessLevel = SubscriptionPlanHelpers.getPlanAccessLevel(subscriptionPlanKey);

    switch (accessLevel) {
        case AccessLevel.Free:
            return "Free";
        case AccessLevel.Pro:
            return "Professional";
        case AccessLevel.Standard:
            return "Standard";
        case AccessLevel.Lite:
            return "Lite";
        default:
            return "";
    }
};
